import {useState} from 'react'
import {GetMyDataForCreateReservationQuery} from '@data/__generated__/types.main'
import useUserId from '@hooks/useUserId'
import {clientNames} from '@providers/services'
import {gql, useQuery} from 'apollo-hooks'

export function useUserData() {
  const userId = useUserId()
  const {data} = useQuery<GetMyDataForCreateReservationQuery>({
    clientName: clientNames.main,
    query: gql`
      query getMyDataForCreateReservation {
        me {
          _id
          profile {
            firstName
            lastName
          }
          email
          phone
        }
      }
    `,
    omit: !userId
  })

  const [firstName, setFirstName] = useState<string>()
  const [lastName, setLastName] = useState<string>()
  const [email, setEmail] = useState<string>()
  const [phone, setPhone] = useState<string>()

  if (data?.me) {
    return {
      userId: data.me._id,
      firstName: data?.me?.profile?.firstName,
      setFirstName,
      lastName: data?.me?.profile?.lastName,
      setLastName,
      email: data?.me?.email,
      setEmail,
      phone: data?.me?.phone,
      setPhone
    }
  } else {
    return {
      userId: null,
      firstName,
      setFirstName,
      lastName,
      setLastName,
      email,
      setEmail,
      phone,
      setPhone
    }
  }
}
